module.exports = __webpack_public_path__ + "img/Moonbase_Sharing.be488ea7.png";